// extracted by mini-css-extract-plugin
export default {"back_link":"monitoringBackLink_back_link__20Xu1","back_title":"monitoringBackLink_back_title__Fj-xE","back_edit":"monitoringBackLink_back_edit__hIXQ9"};